export default __webpack_public_path__ + "static/media/promo-issue-no-1_04.860e78bc.jpg";